import request from "@/router/axios"; // 公共部分
// 查询区域级联列表

export function citysList(param) {
  return request({
    url: "/api/blade-system/region/lazy-tree",
    method: "get",
    params: param
  });
} // 查询类型列表

export function typeList(param) {
  return request({
    url: "/api/blade-system/dict-biz/list",
    method: "get",
    params: param
  });
} // 查询人员列表

export function getUserList() {
  return request({
    url: "/api/blade-user/user-list",
    method: "get"
  });
} //
// 查询维保档案分页

export function tableData(param) {
  return request({
    url: "/api/maintenance/page",
    method: "get",
    params: param
  });
} // 查询维保记录

export function recordById(param) {
  return request({
    url: "/api/maintenance/getRecordById",
    method: "get",
    params: param
  });
} // 派单

export function assignDutyUser(param) {
  return request({
    url: "/api/maintenance/assignDutyUser",
    method: "put",
    data: param
  });
} // 维保处理

export function tlMaintenance(param) {
  return request({
    url: "/api/tlMaintenance",
    method: "post",
    data: param
  });
} // 报修相关
// 根据空调编号查询信息

export function getDetailByDevNumber(param) {
  return request({
    url: "/api/device/getDetailByDevNumber",
    method: "get",
    params: param
  });
} // 查询项目列表

export function projectList(param) {
  return request({
    url: "/api/project/list",
    method: "get",
    params: param
  });
} // 根据项目id查询楼号列表

export function towerList(param) {
  return request({
    url: "/api/device/getTowerNumsByProjectId",
    method: "get",
    params: param
  });
} // 根据楼号查询梯号列表

export function stairList(param) {
  return request({
    url: "/api/device/getStairsNumsByTowerNum",
    method: "get",
    params: param
  });
} // 根据梯号查询设备详情

export function getDeviceByStairsNum(param) {
  return request({
    url: "/api/device/getDeviceByStairsNum",
    method: "get",
    params: param
  });
} // 维保报修

export function maintenanceHandle(param) {
  return request({
    url: "/api/maintenance",
    method: "post",
    data: param
  });
} // 删除操作

export function maintenanceDelete(param) {
  return request({
    url: "/api/maintenance/".concat(param.id),
    method: "delete"
  });
}